<template>
  <div class="dropdown-container">
    <MultiSelect 
      v-model="selectedValues" 
      :options="options" 
      optionLabel="Glosa" 
      optionValue="Id" 
      placeholder="Selecciona Cursos" 
      :class="{'p-invalid': mostrarErrores && error}" 
      v-bind:[tooltipDirective]="tooltip" 
      @change="emitSelection"
      display="chip"
      :multiple="multiple"
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import CursoService from '@/services/CursoService'; // Importa el servicio
import { MultiSelect } from 'primevue/multiselect'; // Importa el componente MultiSelect

export default {
  components: {
    MultiSelect // Registra el componente MultiSelect
  },
  props: {
    mostrarErrores: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Array, // Cambiado a Array para permitir múltiples selecciones
      default: () => []
    },
    multiple: { // Nueva propiedad para controlar si es múltiple o no
      type: Boolean,
      default: true // Por defecto, permite múltiples selecciones
    }
  },
  setup(props, { emit }) {
    const options = ref([]);
    const selectedValues = ref(props.modelValue);

    const fetchOptions = async () => {
      try {
        const response = await CursoService.get(); // Llama al método getCursos
        options.value = response.data; // Asegúrate de que la respuesta tenga la estructura correcta
      } catch (error) {
        console.error('Error al cargar opciones:', error);
      }
    };

    const emitSelection = () => {
      emit('update:modelValue', selectedValues.value); // Emitir el array de valores seleccionados
    };

    onMounted(() => {
      fetchOptions();
    });

    return {
      options,
      selectedValues,
      emitSelection
    };
  }
}
</script>

<style scoped>
.dropdown-container {
  margin-bottom: 1rem;
  max-height: 200px; /* Ajusta la altura máxima según sea necesario */
  max-width: 100%;
  overflow-y: auto; /* Permite el scroll vertical */
}

.p-multiselect {
  width: 100%; /* Asegúrate de que el MultiSelect ocupe el ancho completo */
}
</style>